import { render } from "./VirtualRedTagHeader.vue?vue&type=template&id=fe7107c8&scoped=true&ts=true"
import script from "./VirtualRedTagHeader.vue?vue&type=script&lang=ts"
export * from "./VirtualRedTagHeader.vue?vue&type=script&lang=ts"

import "./VirtualRedTagHeader.vue?vue&type=style&index=0&id=fe7107c8&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe7107c8"]])

export default __exports__